import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-edd547a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TabSwitchArrow" }
const _hoisted_2 = { class: "TabSwitchArrow-list" }
const _hoisted_3 = ["title", "onClick"]
const _hoisted_4 = { class: "TabSwitchArrow-switch" }
const _hoisted_5 = { class: "TabSwitchArrow-switch-icon left" }
const _hoisted_6 = { class: "TabSwitchArrow-switch-icon right" }

import { reactive, watch, nextTick } from 'vue'
import { t } from '@/plugins/i18n'


export default /*#__PURE__*/_defineComponent({
  props: {
  list: {
    type: Array as () => Array<any>,
    default: () => []
  },
  // 一页几个
  size: {
    type: Number,
    default: 8
  },
  // 当前选中的id
  curId: {
    type: [String, Number],
    default: ''
  },
  idKey: {
    type: String,
    default: 'shopCode'
  },
  labelKey: {
    type: String,
    default: 'shopName'
  }
},
  emits: ['update:selected', 'update:pageNum'],
  setup(__props, { emit: emits }) {

const props = __props


// 监听传入list改变
watch(() => props.list, (list) => {
  nextTick(() => {
    data.page.total = list.length
    // getListByPage()
  })
}, { immediate: true })



const data: any = reactive({
  // 列表
  list: [],
  // 分页对象
  page: {
    currentPage: 1,
    pageSize: props.size,
    total: 0
  }
})

// 选中
const selected = (id: any, item: any) => {
  emits('update:selected', id, item)
}

// 按照分页获取展示数组
// const getListByPage = () => {
//   const { currentPage, pageSize, total } = data.page
//   const start = (currentPage - 1) * pageSize
//   const end = currentPage * pageSize
//   data.list = props.list.slice(start, end)
// }

// 分页改变
const pageChange = (page: number) => {
  if (page > data.page.currentPage) {
    emits('update:pageNum', page)
  }
  data.page.currentPage = page
  // getListByPage()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "TabSwitchArrow-list-scroll tstnc",
        style: _normalizeStyle({ left: `${(_unref(data).page.currentPage - 1) * -1040}px` })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["TabSwitchArrow-list-item", { 'active': __props.curId === item[__props.idKey] }]),
            key: item[__props.idKey],
            title: item[__props.labelKey] ?? item[__props.labelKey],
            onClick: ($event: any) => (selected(item[__props.idKey], item))
          }, _toDisplayString(item[__props.labelKey] ? item[__props.labelKey] : '-'), 11, _hoisted_3))
        }), 128))
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("img", {
          class: "wrap",
          src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAALVBMVEUAAABRUVFRUVFKSkpRUVFSUlJRUVFRUVFRUVFRUVFSUlJSUlJQUFBSUlJRUVG2stTSAAAADnRSTlMA7cELZGrY6bGaiVEzGd7zTKEAAABfSURBVBjTY8AGjl5AsFnfKSA4ce8K4GyWd+8E4Bw/EAchgeD4gTgICQTHD8yBSyA4+5A5fcicdcgcI2QOsx6y0UYQDkIK4RwjCAchhfCCEYiDkAJxEFIJCA7zNAcgCQA5K0YCDb5YcgAAAABJRU5ErkJggg==",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (pageChange(_unref(data).page.currentPage - 1)))
        }, null, 512), [
          [_vShow, _unref(data).page.currentPage > 1]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("img", {
          class: "wrap",
          src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAXBAMAAADjD5IeAAAAMFBMVEUAAABSUlJQUFBRUVFSUlJRUVFQUFBPT09HR0dRUVFSUlJQUFBRUVFQUFBRUVFRUVFibUY3AAAAD3RSTlMAV+EhbWtKJgz728uuZkLMF+1UAAAAXElEQVQY003JsQ2AMBBDUVPRIXa4BRiBERiBBZAYIfuxDboU0BwnBcV25aeP3DWjb4pKDBGbwhWxKpxoiXCiJaIqnlMQu+AtAgNxLwIDkYEwEBkIA8GAMQN3lP982DRV+7cFhcIAAAAASUVORK5CYII=",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (pageChange(_unref(data).page.currentPage + 1)))
        }, null, 512), [
          [_vShow, _unref(data).page.currentPage * _unref(data).page.pageSize <= _unref(data).page.total]
        ])
      ])
    ])
  ]))
}
}

})